<div class="block-column">
  <div>
    <h1>デザインガイドラインに沿ったラジオボタン</h1>
    <h2>ラジオボタンコンポーネント</h2>
    <div class="column-list">
      <label class="list-input-title">項目名7（app-checkbox-label）</label>
      <div class="list-input-content">
        <app-radio-label [name]="'0'" label="ラジオボタンラベル1"></app-radio-label>
        <app-radio-label [name]="'0'" label="ラジオボタンラベル2"></app-radio-label>
        <app-radio-label [name]="'0'" label="ラジオボタンラベル3"></app-radio-label>
        <app-radio-label [name]="'0'" label="ラジオボタンラベル4"></app-radio-label>
      </div>
    </div>
    <div class="column-list">
      <label class="list-input-title">項目名7（app-checkbox-label）</label>
      <div class="list-input-content">
        <div class="element-column">
          <app-radio-label [name]="'1'" label="ラジオボタンラベル1"></app-radio-label>
          <app-radio-label [name]="'1'" label="ラジオボタンラベル2"></app-radio-label>
          <app-radio-label [name]="'1'" label="ラジオボタンラベル3"></app-radio-label>
          <app-radio-label [name]="'1'" label="ラジオボタンラベル4"></app-radio-label>
        </div>
      </div>
    </div>
  </div>

  <div>
    <h2>ラジオボタンのステータス</h2>
    <div class="column-list">
      <label class="list-input-title">項目名7（app-checkbox-label）</label>
      <div class="list-input-content">
        <app-radio-label [name]="'2'" label="未チェック"></app-radio-label>
        <app-radio-label [name]="'3'" [checked]="true" label="チェック済"></app-radio-label>
        <app-radio-label [name]="'4'" [disabled]="true" label="非活性化・未チェック"></app-radio-label>
        <app-radio-label [name]="'5'" [disabled]="true" [checked]="true" label="非活性化・チェック済"></app-radio-label>
      </div>
    </div>
  </div>

  <div>
    <h1>デザインガイドラインに沿ったチェックボックス</h1>
    <h2>純粋なチェックボックス</h2>
    <div>
      <div class="column-list">
        <label class="list-input-title">純粋なチェックボックス1</label>
        <div class="list-input-content">
          <label><input type="checkbox" class="checkbox">チェックボックスラベル</label>
        </div>

        <label class="list-input-title">純粋なチェックボックス2</label>
        <div class="list-input-content">
          <label class="checkbox-label">
            <input type="checkbox" />
            <span>チェックボックスラベル</span>
          </label>
        </div>

        <label class="list-input-title">純粋なチェックボックス3(廃止予定)</label>
        <div class="list-input-content">
          <input type="checkbox" />
          <label>掲載あり（ラベルをチェックしてもチェックが入らないので廃止予定）</label>
        </div>

        <label class="list-input-title">純粋なチェックボックス4</label>
        <div class="list-input-content">
          <input type="checkbox">
          <input type="checkbox">
          <input type="checkbox">
          <input type="checkbox">
        </div>
      </div>
    </div>
  </div>

  <div>
    <h2>チェックボックスコンポーネント</h2>
    <div class="column-list">
      <label class="list-input-title">チェックボックスコンポーネント(checkbox-label)</label>
      <div class="list-input-content">
        <app-checkbox-label [label]="'チェックボックスラベル'"></app-checkbox-label>
      </div>

      <label class="list-input-title">商品ＤＮＡ情報ボックスリスト</label>
      <div class="list-input-content">
        <app-dna-info-check-box-list [height]="'10vh'"></app-dna-info-check-box-list>
      </div>

      <label class="list-input-title">コード定義チェックボックス</label>
      <div class="list-input-content">
        <app-code-check-box-list [codeDiv]="'ctp123'" [height]="'10vh'"></app-code-check-box-list>
      </div>
    </div>
  </div>

  <div>
    <h2>チェックボックスのステータス</h2>
    <div class="column-list">
      <label class="list-input-title">チェックボックス（Enable）</label>
      <div class="list-input-content">
        <label>
          <input type="checkbox">未選択状態
        </label>
      </div>
      <label class="list-input-title">チェックボックス（Disable）</label>
      <div class="list-input-content">
        <label>
          <input type="checkbox" disabled>非活性状態
        </label>
      </div>
      <label class="list-input-title">チェックボックス（Enable）</label>
      <div class="list-input-content">
        <label>
          <input type="checkbox" checked>選択状態
        </label>
      </div>
      <label class="list-input-title">チェックボックス（Disable）</label>
      <div class="list-input-content">
        <label>
          <input type="checkbox" checked disabled>選択状態の非活性状態
        </label>
      </div>
    </div>
  </div>

  <div>
    <h2>インプットのdisabledとreadonly</h2>
    <div class="column-list">
      <label class="list-input-title">DEFAULT</label>
      <div class="list-input-content">
        <input type="text" value="これはデザインガイドラインで定義されているDEFAULT属性のテキストです" [style.width.px]="200" [tabindex]="0">
      </div>
      <label class="list-input-title">READONLY</label>
      <div class="list-input-content">
        <input type="text" value="これはREADONLY属性です。フォーカスが当たり、テキスト自体も選択ができます。" [style.width.px]="200"  readonly>
      </div>
      <label class="list-input-title">DISABLED</label>
      <div class="list-input-content">
        <input type="text" value="これはDISABLED属性です。フォーカスは当たりませんが、テキストは選択できます。" [style.width.px]="200" disabled>
      </div>
    </div>
  </div>

  <div>
    <h2>ラベルとインプット要素の並べ方</h2>
    <div class="column-list">
      <label class="list-input-title">並べ方1</label>
      <div class="list-input-content">
        <input type="text" value="INPUTテキスト" [style.width.px]="200" disabled>
        <label><input type="checkbox" checked>選択済</label>
      </div>
      <label class="list-input-title">並べ方2</label>
      <div class="list-input-content">
        <label><input type="checkbox" checked>選択済</label>
        <input type="text" value="INPUTテキスト" [style.width.px]="200" disabled>
      </div>
      <label class="list-input-title">並べ方3</label>
      <div class="list-input-content">
        <div>
          <label class="checkbox-label">
            <input type="checkbox" />
            <span>選択1</span>
          </label>
          <label class="checkbox-label">
            <input type="checkbox" />
            <span>選択2</span>
          </label>
          <label class="checkbox-label">
            <input type="checkbox" />
            <span>選択3</span>
          </label>
        </div>
      </div>
    </div>
    <div class="input_vertical">
      <div class="label_input_vertical">
        <div class="list-title_checkbox_beside">
          <div class="list-input-title flex-balance">
            <label >並べ方4</label>
          </div>
          <div class="flex-balance checkbox_btn_beside">
            <div class="flex">
              <div class="label_checkbox">
                <label><input type="checkbox" />媒体別</label>
              </div>
            </div>
            <button class="btn-secondary">候補を表示</button>
          </div>
        </div>
        <div class="list-input-content grid-row-textinfo8">
          <app-text-area [disabled]="true" [counterWidth]="'60px'" [subid]="'txta_TextInfo8'" [maxChars]="200"
            [fullOnly]="true" [allowMultiLine]="false">
          </app-text-area>
        </div>
      </div>
    </div>
  </div>

  <div>
    <h1>見出しHEADING-L</h1>
    <h2>見出しHEADING-M</h2>
    <h3>見出しHEADING-S</h3>
  </div>

  <div>
    <h1>配置方法</h1>
    <h2>フレックス（横配置）</h2>
    <div class="block-row">
      <div style="padding:16px; color:white; background: red;">フレックス1</div>
      <div style="padding:16px; color:white; background: blue;">フレックス2</div>
      <div style="padding:16px; color:white; background: red;">フレックス3</div>
      <div style="padding:16px; color:white; background: blue;">フレックス4</div>
      <div style="padding:16px; color:white; background: red;">フレックス5</div>
    </div>

    <h2>フレックス（縦配置）</h2>
    <div class="block-column">
      <div style="padding:16px; color:white; background: red;">フレックス1</div>
      <div style="padding:16px; color:white; background: blue;">フレックス2</div>
      <div style="padding:16px; color:white; background: red;">フレックス3</div>
      <div style="padding:16px; color:white; background: blue;">フレックス4</div>
      <div style="padding:16px; color:white; background: red;">フレックス5</div>
    </div>

    <h2>フレックス（右寄せ配置）</h2>
    <div class="layout_end">
      <div style="padding:16px; color:white; background: red;">フレックス1</div>
      <div style="padding:16px; color:white; background: blue;">フレックス2</div>
      <div style="padding:16px; color:white; background: red;">フレックス3</div>
      <div style="padding:16px; color:white; background: blue;">フレックス4</div>
      <div style="padding:16px; color:white; background: red;">フレックス5</div>
    </div>

    <h2>フレックス（バランス配置）</h2>
    <div class="layout_balance">
      <div style="padding:16px; color:white; background: red;">フレックス1</div>
      <div style="padding:16px; color:white; background: blue;">フレックス2</div>
      <div style="padding:16px; color:white; background: red;">フレックス3</div>
      <div style="padding:16px; color:white; background: blue;">フレックス4</div>
      <div style="padding:16px; color:white; background: red;">フレックス5</div>
    </div>
  </div>

  <div>
    <h1>項目UI</h1>
    <div class="column-list">
      <label class="list-input-title">項目名1</label>
      <div class="list-input-content">項目内容（div）</div>

      <label class="list-input-title">項目名2</label>
      <label class="list-input-content">項目内容（label）</label>

      <label class="list-input-title">項目名3（input=text）</label>
      <div class="list-input-content"><input type="text" value="INPUTテキスト"></div>

      <label class="list-input-title">項目名4（input=text・入力必須）</label>
      <div class="list-input-content"><input type="text" class="text-label-required" value="入力必須INPUTテキスト"></div>

      <label class="list-input-title">項目名5（textarea）</label>
      <div class="list-input-content"><textarea class="text-label-normal">テキストエリア</textarea></div>

      <label class="list-input-title">項目名6（selectボックス）</label>
      <div class="list-input-content">
        <select class="combo-box-normal">
          <option>なにかしら</option>
        </select>
      </div>

      <label class="list-input-title">項目名9（app-not-null-text-input）</label>
      <div class="list-input-content">
        <app-not-null-text-input [width]="'80%'" [maxChars]="30" [displayCountField]="true"></app-not-null-text-input>
      </div>

      <label class="list-input-title">項目名10（app-not-null-text-area)</label>
      <div class="list-input-content">
        <app-not-null-text-area [maxChars]="100" [displayCountField]="true"></app-not-null-text-area>
      </div>

      <label class="list-input-title">項目名11（wj-input-number）</label>
      <div class="list-input-content">
        <wj-input-number class="numeric-stepper" [step]="1" [min]="-5" [max]="5" [value]="0"
          format="n0"></wj-input-number>
      </div>

      <label class="list-input-title">項目名12（app-text-input)</label>
      <div class="list-input-content">
        <app-text-input id="text-app-text-input" [subid]="'texi-app-text-input'" [forcedEnabledMode]="'true'"
          [width]="'30rem'" [maxChars]="30" [restrict]="'[ -￮]'" [fullOnly]="false" [halfOnly]="false"
          [allowMultiLine]="false" [toUpperCase]="false" [editable]="true" [tabEnabled]="true" [tabindex]="0"
          [verticalScrollPolicy]="'auto'" [displayCountField]="true" [disabled]="false"></app-text-input>
      </div>

      <label class="list-input-title">項目名13（app-text-area）</label>
      <div class="list-input-content">
        <app-text-area id="text-app-area" [subid]="'texa-app-text-area'" [forcedEnabledMode]="'true'" [maxChars]="100"
          [fullOnly]="false" [halfOnly]="false" [allowMultiLine]="true" [toUpperCase]="false" [editable]="true"
          [tabEnabled]="true" [tabindex]="0" [verticalScrollPolicy]="'auto'" [horizontalScrollPolicy]="'auto'"
          [displayCountField]="false" [disabled]="false"></app-text-area>
      </div>
    </div>
  </div>

  <div>
    <h1>項目UI(4列)</h1>
    <div class="element-column">
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">項目名1</label>
          <div class="list-input-content"><input type="text" value="項目内容（readonly）" readonly></div>
        </div>
        <div class="column-list">
          <label class="list-input-title">項目名3（input=text）</label>
          <div class="list-input-content"><input type="text" value="INPUTテキスト"></div>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title">項目名4（input=text・入力必須）</label>
        <div class="list-input-content"><input type="text" class="text-label-required"
            value="3列分の入力必須INPUTテキスト"></div>
        <label class="list-input-title">項目名6（selectボックス）</label>
        <div class="list-input-content">
          <select class="combo-box-normal">
            <option>3列分のなにかしら</option>
          </select>
        </div>
      </div>
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">項目名7（app-checkbox-label）</label>
          <div class="list-input-content">
            <app-checkbox-label [label]="'チェックボックスラベル'"></app-checkbox-label>
          </div>
        </div>
        <div class="column-list">
          <label class="list-input-title">項目名8（app-not-null-text-area）</label>
          <div class="list-input-content">
            <app-not-null-text-area [maxChars]="200" [displayCountField]="false"></app-not-null-text-area>
          </div>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title">項目名9（app-radio-label）</label>
        <div class="list-input-content">
          <app-radio-label label="ラジオボタンラベル１"></app-radio-label>
          <app-radio-label label="ラジオボタンラベル２"></app-radio-label>
        </div>
      </div>
    </div>
  </div>

  <div>
    <h1>Wijmo表（wj-flex-grid）</h1>
    <div style="position:relative;max-width:1610px;width:100%;height:125px;">
      <wj-flex-grid style="max-width:1610px;width:100%;height:125px;"
        [itemsSource]="[{col1:1,col2:2,col3:4,col4:4},{col1:1,col2:2,col3:4,col4:4}]" [isReadOnly]="true"
        [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
        <wj-flex-grid-column [header]="'列１'" [width]="300" [binding]="'col1'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'列２'" [width]="700" [binding]="'col2'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'列３'" [width]="500" [binding]="'col3'"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'列４'" [width]="100" [binding]="'col4'"></wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>

  <div>
    <h1>共通部品</h1>
    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title">会員生協コンボボックス</label>
        <div class="list-input-content">
          <app-coop-code-combo-box></app-coop-code-combo-box>
        </div>

        <label class="list-input-title">部門コードコンボボックス</label>
        <div class="list-input-content">
          <app-class-code-combo-box></app-class-code-combo-box>
        </div>

        <label class="list-input-title">コードコンボボックス</label>
        <div class="list-input-content">
          <app-code-combo-box [codeDiv]="'ct366'"></app-code-combo-box>
        </div>

        <label class="list-input-title">ページリスト</label>
        <div class="list-input-content">
          <app-page-combo-box [orderCode]="'2023160'" [mediumType]="'001'" [coopCode]="'142'"></app-page-combo-box>
        </div>

        <label class="list-input-title">撮影場所コンボボックス</label>
        <div class="list-input-content">
          <app-studio-master-combo-box></app-studio-master-combo-box>
        </div>

        <label class="list-input-title">全媒体コンボボックス</label>
        <div class="list-input-content">
          <app-vmedium-type-combo-box></app-vmedium-type-combo-box>
        </div>

        <label class="list-input-title">NotNullTextInput</label>
        <div class="list-input-content">
          <app-not-null-text-input [width]="'80%'" [maxChars]="100"></app-not-null-text-input>
        </div>

        <label class="list-input-title">マークコードテキストインプット</label>
        <div class="list-input-content">
          <app-mark-code-text-input maxlength="3" [restrict]="'[0-9]'" [markNameField]="lblMarkName"
            [width]="'50%'"></app-mark-code-text-input>
          <label #lblMarkName></label>
        </div>

        <label class="list-input-title">受注コードテキストインプット</label>
        <div class="list-input-content">
          <app-order-code-text-input></app-order-code-text-input>
        </div>

        <label class="list-input-title">NotNullTextArea</label>
        <div class="list-input-content">
          <app-not-null-text-area [maxChars]="100"></app-not-null-text-area>
        </div>

        <label class="list-input-title">カテゴリ変換区分コンボボックス</label>
        <div class="list-input-content">
          <app-conv-div-combo-box [categoryDiv]="'1'"></app-conv-div-combo-box>
        </div>

        <label class="list-input-title">EC商品企画カテゴリコンボボックス</label>
        <div class="list-input-content">
          <app-cws-plan-category-code-combo-box #cmbCwsPlanCategoryCode
            [categoryLevel]="1"></app-cws-plan-category-code-combo-box>
        </div>

        <label class="list-input-title">DnaInfoComboBox</label>
        <div class="list-input-content">
          <app-dna-info-combo-box></app-dna-info-combo-box>
        </div>

        <label class="list-input-title">ECグルーピングコンボボックス</label>
        <div class="list-input-content">
          <app-grouping-code-combo-box #cmbGroupingCode></app-grouping-code-combo-box>
        </div>

        <label class="list-input-title">大分類コードコンボボックス</label>
        <div class="list-input-content">
          <app-large-class-code-combo-box></app-large-class-code-combo-box>
        </div>

        <label class="list-input-title">中分類コードコンボボックス</label>
        <div class="list-input-content">
          <app-middle-class-code-combo-box></app-middle-class-code-combo-box>
        </div>

        <label class="list-input-title">小分類コードコンボボックス</label>
        <div class="list-input-content">
          <app-small-class-code-combo-box #cmbSmallClassCode [classCodeComboBoxFlg]="false"
            [largeClassCodeComboBoxFlg]="true" [largeClassCode]="'10'"
            [middleClassCode]="'1009'"></app-small-class-code-combo-box>
        </div>
      </div>
      <div class="column-list">

        <label class="list-input-title">媒体コンボボックス</label>
        <div class="list-input-content">
          <app-medium-type-combo-box></app-medium-type-combo-box>
        </div>

        <label class="list-input-title">注文コード割当コードコンボボックス</label>
        <div class="list-input-content">
          <app-order-num-quota-code-combo-box [mediumType]="'001'"
            [orderCode]="'2023110'"></app-order-num-quota-code-combo-box>
        </div>

        <label class="list-input-title">受注コード期間マスタコンボボックス</label>
        <div class="list-input-content">
          <app-period-seq-combo-box></app-period-seq-combo-box>
        </div>

        <label class="list-input-title">プロモーションコードコンボボックス</label>
        <div class="list-input-content">
          <app-promotion-code-combo-box [codeDiv]="'ctp109'"></app-promotion-code-combo-box>
        </div>

        <label class="list-input-title">プロモーション情報コンボボックス</label>
        <div class="list-input-content">
          <app-promotion-info-combo-box></app-promotion-info-combo-box>
        </div>

        <label class="list-input-title">売り場コードコンボボックス</label>
        <div class="list-input-content">
          <app-sell-area-code-combo-box [mediumType]="'029'" [initAutoLoad]="true"></app-sell-area-code-combo-box>
        </div>

        <label class="list-input-title">業態別媒体区分コンボボックス</label>
        <div class="list-input-content">
          <app-vmedium-duties-form-type-combo-box></app-vmedium-duties-form-type-combo-box>
        </div>

        <label class="list-input-title">部門情報リスト</label>
        <div class="list-input-content">
          <app-classifications-list></app-classifications-list>
        </div>

        <label class="list-input-title">コードリスト</label>
        <div class="list-input-content">
          <app-code-list [codeDiv]="'ct357'" [height]="'10vh'"></app-code-list>
        </div>

        <label class="list-input-title">企画進捗管理テキストインプット</label>
        <div class="list-input-content">
          <app-catalog-progress-text-input #txtCatalogProgress [catalogIDField]="txtCatalogId"
            [progressWorkNumNameField]="txtPhase" mediumType="001"></app-catalog-progress-text-input>
          <input type="text" #txtCatalogId readonly />
          <input type="text" #txtPhase readonly />
        </div>

        <label class="list-input-title">アイコンコードテキストインプット</label>
        <div class="list-input-content">
          <app-icon-code-text-input [iconNameField]="lblIconName" [width]="'50%'"></app-icon-code-text-input>
          <label #lblIconName></label>
        </div>

        <label class="list-input-title">スライダー</label>
        <div class="list-input-content">
          <input type="range" min="50" max="400" step="10">
        </div>
      </div>
    </div>
  </div>
  
  <div>
    <h1>ダイアログ表示</h1>
    <div class="slider-area">
      <button class="btn-secondary" (click)="open_AlertDialog()">AlertDialog</button>
      <button class="btn-secondary" (click)="open_ScreenDialog()">ScreenDialog</button>
    </div>
  </div>
  
  <div>
    <h1>ダイアログ表示</h1>
    <div class="flex">
      <button class="btn-secondary" (click)="eventSeach_CLICKHandler()">商品検索</button>
      <button class="btn-secondary" (click)="eventKYMW0400_CLICKHandler(false)">取引先一覧（単数）</button>
      <button class="btn-secondary" (click)="eventKYMW0400_CLICKHandler(true)">取引先一覧（複数）</button>
      <button class="btn-secondary" (click)="eventKYMW0E00_CLICKHandler()">使用ページ確認</button>
      <button class="btn-secondary" (click)="eventKYMW0900_CLICKHandler()">商品企画メンテナンス</button>
      <button class="btn-secondary" (click)="eventKYMW0F00_CLICKHandler()">グルーピング選択</button>
      <button class="btn-secondary" (click)="eventKYMW5002_CLICKHandler()">EC使用画像指示</button>
      <button class="btn-secondary" (click)="eventKYMW0002_CLICKHandler()">タグ選択</button>
      <button class="btn-secondary" (click)="eventKYMW0003_CLICKHandler()">企画支援選択</button>
      <button class="btn-secondary" (click)="eventKYMW1202_CLICKHandler()">掲載媒体設定</button>
      <button class="btn-secondary" (click)="eventKYMW0600_CLICKHandler()">関連Pコード設定</button>
      <button class="btn-secondary" (click)="eventKYMW0001_CLICKHandler()">マーク選択</button>
      <!-- <button class="btn-secondary" (click)="eventKYMW1705_CLICKHandler()">過去画像登録</button> -->
      <!-- <button class="btn-secondary" (click)="eventKYMW1707_CLICKHandler()">催促メール定型文選択</button> -->
      <!-- <button class="btn-secondary" (click)="eventKYMW1708_CLICKHandler()">複数コード登録</button> -->
      <!-- <button class="btn-secondary" (click)="eventKYMW1709_CLICKHandler()">アップロード画像確認</button> -->
      <button class="btn-secondary" (click)="eventKYMW2000_CLICKHandler()">選定済商品数一覧画面</button>
      <button class="btn-secondary" (click)="eventKYMW9006_CLICKHandler()">パスワード変更</button>
      <button class="btn-secondary" (click)="eventKYMW1318_CLICKHandler()">受注コード指定選定解除</button>
      <button class="btn-secondary" (click)="eventKYMW0b00_CLICKHandler()">画像検索</button>
      <button class="btn-secondary" (click)="eventKYMW7403_CLICKHandler()">忘れず注文商品リスト出力</button>
      <button class="btn-secondary" (click)="eventKYMW7401_CLICKHandler()">忘れず注文商品対象選択</button>
      <button class="btn-secondary" (click)="eventKYMW1317_CLICKHandler()">企画連絡承認</button>
      <button class="btn-secondary" (click)="eventKYMW1108_CLICKHandler()">商品仕様取込（KYMW1108）</button>
      <button class="btn-secondary" (click)="eventKYMW1319_CLICKHandler()">特集付替設定</button>
      <button class="btn-secondary" (click)="eventKYMW0906Add_CLICKHandler()">予約商品設定(追加)</button>
      <button class="btn-secondary" (click)="eventKYMW0906Detail_CLICKHandler()">予約商品設定(詳細)</button>
    </div>
  </div>

  <div>
    <h1>ダイアログ表示：画像作成管理 (KYMW17)</h1>
    <div class="column-list">
      <label class="list-input-title">KYMW1705 過去画像登録</label>
      <div class="list-input-content">
        <button class="btn-secondary" (click)="eventKYMW1705_CLICKHandler()">過去画像登録</button>
        <input type="text" #txt_param1705_imageId placeholder="画像ID" style="width:150px;">
      </div>
      <label class="list-input-title">KYMW1706 差し戻し理由入力</label>
      <div class="list-input-content">
        <button class="btn-secondary" (click)="eventKYMW1706_CLICKHandler()">差し戻し</button>
        <input type="text" #txt_param1706_guideGoodsName placeholder="商品案内用商品名" style="width:150px;">
        <input type="text" #txt_param1706_guideStandardName placeholder="商品案内用規格名" style="width:150px;">
        <input type="text" #txt_param1706_imageFileName placeholder="画像ファイル名" style="width:150px;">
      </div>
      <label class="list-input-title">KYMW1707 催促メール定型文選択</label>
      <div class="list-input-content">
        <button class="btn-secondary" (click)="eventKYMW1707_CLICKHandler()">催促</button>
        <input type="text" #txt_param1707_sampleOrderingName placeholder="サンプル発注先名称" style="width:150px;">
        <input type="text" #txt_param1707_supplierInfo placeholder="取引先への連絡事項" style="width:150px;">
        <input type="text" #txt_param1707_imageFileName placeholder="画像ファイル名" style="width:150px;">
      </div>
      <label class="list-input-title">KYMW1708 複数コード登録</label>
      <div class="list-input-content">
        <button class="btn-secondary" (click)="eventKYMW1708_CLICKHandler()">複数コード登録</button>
        <input type="text" #txt_param1708_imageId placeholder="画像ID" style="width:150px;">
      </div>
      <label class="list-input-title">KYMW1709 アップロード画像確認</label>
      <div class="list-input-content">
        <button class="btn-secondary" (click)="eventKYMW1709_CLICKHandler()">アップロード画像確認</button>
        <input type="text" #txt_param1709_imageFileName placeholder="画像ファイル名" style="width:150px;">
      </div>
    </div>
  </div>

  <div>
    <h1>マークアイコンマスタ管理子画面</h1>
    <div class="flex">
      <button class="btn-secondary" (click)="eventKYMW1503_CLICKHandler()">マーク登録</button>
      <button class="btn-secondary" (click)="eventKYMW1504_CLICKHandler()">マークファイル登録</button>
      <button class="btn-secondary" (click)="eventKYMW1505_CLICKHandler()">マーク掲載順設定</button>
      <button class="btn-secondary" (click)="eventKYMW1506_CLICKHandler()">アイコン登録</button>
      <button class="btn-secondary" (click)="eventKYMW1507_CLICKHandler()">別アイコンファイル登録</button>
      <button class="btn-secondary" (click)="eventKYMW1508_CLICKHandler()">アイコン情報編集</button>
      <button class="btn-secondary" (click)="eventKYMW1509_CLICKHandler()">アイコン掲載順設定</button>
      <button class="btn-secondary" (click)="eventKYMW1510_CLICKHandler()" [style.width.px]="220">アイコンファイル適用期間指定</button>
    </div>
  </div>
  
  <div>
    <h1>クロスコード設定子画面</h1>
    <div class="flex">
      <button class="btn-secondary" (click)="eventKYMW4802_CLICKHandler()">クロス商品設定</button>
    </div>
  </div>
  
  <div>
    <h1>メイン画面の遷移</h1>
    <div class="flex">
      <button class="btn-secondary" style="width:400px" (click)="eventKYMW7007_CLICKHandler()">表紙・特集商品選定依頼確認（担当バイヤー用）</button>
      <button class="btn-secondary" (click)="eventKYMW1201_CLICKHandler()">企画回別商品一覧</button>
      <button class="btn-secondary" (click)="eventKYMW7402_CLICKHandler()">忘れず注文商品登録</button>
    </div>
    <div class="flex">
      <button class="btn-secondary" style="width:400px" (click)="eventKYMW6001_CLICKHandler()">商品画像情報</button>
    </div>
  </div>

  <div>
    <h1>ログイン画面の遷移</h1>
    <button class="btn-secondary" (click)="eventKYMW9007_CLICKHandler()">パスワード再設定</button>
    <button class="btn-secondary" (click)="eventKYMW9008_CLICKHandler()">2要素認証</button>
    <button class="btn-secondary" (click)="eventKYMW9011_CLICKHandler()">パスワード再設定入力</button>
    <button class="btn-secondary" (click)="eventKYMW1003_CLICKHandler()">ログインエラー</button>
  </div>

  <div>
    <h1>From ～ TO</h1>
    <p> 地味にバランス取るのが面倒なのと，いろんなところで xxx ～ yyy 表記しているので共通化</p>
    <div class="column-list">
      <label class="list-input-title">受付番号</label>
      <div class="list-input-content from-to">
        <input type="text" id="txti_ReceiptNumFrom" [tabindex]="0" maxlength="9" forcedEnabledMode="true"
          plessInputTextSub [restrict]="'[0-9]'">
        <label>～</label>
        <input type="text" id="txti_ReceiptNumTo" [tabindex]="0" maxlength="9" forcedEnabledMode="true"
          plessInputTextSub [restrict]="'[0-9]'">
      </div>

      <label class="list-input-title">受注コード</label>
      <div class="list-input-content from-to">
        <app-order-code-text-input id="txt_OrderCodeFrom" #txt_OrderCodeFrom [subid]="'txt_OrderCodeFrom'"
          [required]="true" [initFocusItem]="txt_OrderCodeFrom" [forcedEnabledMode]="'true'" [tabindex]="0"
          maxlength="7">
        </app-order-code-text-input>
        <label>～</label>
        <app-order-code-text-input id="txt_OrderCodeTo" #txt_OrderCodeTo [subid]="'txt_OrderCodeTo'" [required]="true"
          [initFocusItem]="txt_OrderCodeFrom" [forcedEnabledMode]="'true'" [tabindex]="0" maxlength="7">
        </app-order-code-text-input>
      </div>

      <label class="list-input-title">PEACE取込日(最終取込日)</label>
      <div class="list-input-content from-to">
        <wj-input-date id="dtf_ImportDateFrom" #dtf_ImportDateFrom [tabindex]="0" format="yyyy/MM/dd" [max]="maxDate"
          [isRequired]="false" forcedEnabledMode="true">
        </wj-input-date>
        <label>～</label>
        <wj-input-date id="dtf_ImportDateTo" #dtf_ImportDateTo [tabindex]="0" format="yyyy/MM/dd" [isRequired]="false"
          forcedEnabledMode="true">
        </wj-input-date>
      </div>
    </div>
  </div>

  <div>
    <h3>Enable/Disable</h3>
    <div class="column-list">
      <label class="list-input-title">チェックボックス</label>
      <div class="list-input-content">
        <input type="checkbox">Enable
        <input type="checkbox" disabled>Disable
        <input type="checkbox" checked>Enable
        <input type="checkbox" disabled checked>Disable
      </div>

      <label class="list-input-title">ラジオボタン</label>
      <div class="list-input-content">
        <input type="radio" name="radio1" checked>Enable
        <input type="radio" name="radio2" disabled>Disable
        <input type="radio" name="radio1">Enable
        <input type="radio" name="radio2" disabled checked>Disable
      </div>

      <label class="list-input-title">プライマリボタン</label>
      <div class="block-row">
        <button class="btn-primary">保存</button>
        <button class="btn-primary" disabled>実行不可</button>
      </div>

      <label class="list-input-title">セカンダリボタン</label>
      <div class="block-row">
        <button class="btn-secondary">次へ</button>
        <button class="btn-secondary" disabled>検索</button>
      </div>
      <label class="list-input-title">ターシャリボタン</label>
      <div class="block-row">
        <button class="btn-tartiary">戻る</button>
        <button class="btn-tartiary" disabled>戻る(使用不可)</button>
      </div>
      <label class="list-input-title">ターシャリボタン(warning)</label>
      <div class="block-row">
        <button class="btn-tartiary warning">キャンセル</button>
        <button class="btn-tartiary warning" disabled>キャンセル(使用不可)</button>
      </div>
      <label class="list-input-title">クァタナリボタン</label>
      <div class="block-row">
        <button class="btn-quatanary">削除</button>
        <button class="btn-quatanary" disabled>使用禁止</button>
      </div>
    </div>
  </div>

  <div>
    <h1>コープデリ要件定義 新規作成</h1>
    <div class="column-list">
      <label class="list-input-title">多用途コンボボックス</label>
      <div class="list-input-content">
        <app-versatile-combo-box [listSource]="comboTestList" valueField="code" labelField="val" [disabled]="false"
          [required]="true" [width]="200" [height]="20" [tabindex]="0" [visible]="true" [autofocus]="false"
          forcedEnabledMode="true">
        </app-versatile-combo-box>
      </div>
    </div>
  </div>

  <div>
    <details class="accordion">
      <summary>アコーディオン デモ</summary>
      <ul>
        <li>アコーディオンの中身1</li>
        <li>アコーディオンの中身2</li>
        <li>アコーディオンの中身3</li>
        <li>アコーディオンの中身4</li>
        <li>アコーディオンの中身5</li>
        <li>アコーディオンの中身6</li>
      </ul>
    </details>
  </div>

  <div>
    <wj-accordion [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true">
      <wj-accordion-pane>
        <div>アコーディオン1(block-column)</div>
        <div>
          <h1>章タイトル</h1>
          <div class="block-column">
            <div class="column-list">
              <label class="list-input-title">タイトル</label>
              <div class="list-input-content">
                <input type="text" [tabindex]="0" maxlength="9" forcedEnabledMode="true" plessInputTextSub [restrict]="'[0-9]'">
              </div>
            </div>
            <button class="btn-secondary">ボタン</button>
          </div>
        </div>
      </wj-accordion-pane>
      <wj-accordion-pane>
        <div>アコーディオン2(block-row) 左右余白あり</div>
        <div>
          <h1>章タイトル</h1>
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">タイトル</label>
              <div class="list-input-content">
                <input type="text" [tabindex]="0" maxlength="9" forcedEnabledMode="true" plessInputTextSub [restrict]="'[0-9]'">
              </div>
            </div>
            <button class="btn-secondary">ボタン</button>
          </div>
        </div>
      </wj-accordion-pane>
      <wj-accordion-pane>
        <div>アコーディオン3(element-column)</div>
        <div>
          <div class="element-column">
            <div class="column-list">
              <label class="list-input-title">タイトル</label>
              <div class="list-input-content">
                <input type="text" [tabindex]="0" maxlength="9" forcedEnabledMode="true" plessInputTextSub [restrict]="'[0-9]'">
              </div>
            </div>
            <button class="btn-secondary">ボタン</button>
          </div>
        </div>
      </wj-accordion-pane>
      <wj-accordion-pane>
        <div>アコーディオン4(element-row)</div>
        <div>
          <div class="element-row">
            <div class="column-list">
              <label class="list-input-title">タイトル</label>
              <div class="list-input-content">
                <input type="text" [tabindex]="0" maxlength="9" forcedEnabledMode="true" plessInputTextSub [restrict]="'[0-9]'">
              </div>
            </div>
            <button class="btn-secondary">ボタン</button>
          </div>
        </div>
      </wj-accordion-pane>
    </wj-accordion>
  </div>

  <div>
    <h1>テスト用ルーティング</h1>
    <div class="column-list">
      <label class="list-input-title">特集商品提案 (KYMW7002)</label>
      <div class="block-row">
        <div>
          <button class="btn-secondary" (click)="gotoKYMW7002_CreateMode1_CLICKHandler()">
            テスト遷移 1
          </button>
          <p>新規提案：在庫限定</p>
        </div>

        <div>
          <button class="btn-secondary" (click)="gotoKYMW7002_CreateMode2_CLICKHandler()">
            テスト遷移 2
          </button>
          <p>新規提案：在庫限定以外</p>
        </div>

        <div>
          <button class="btn-secondary" (click)="gotoKYMW7002_HistoryMode1_CLICKHandler()">
            テスト遷移 3
          </button>
          <p>履歴確認：在庫限定</p>
        </div>

        <div>
          <button class="btn-secondary" (click)="gotoKYMW7002_HistoryMode2_CLICKHandler()">
            テスト遷移 4
          </button>
          <p>履歴確認：在庫限定以外</p>
        </div>
      </div>
    </div>
  </div>

  <div style="margin-bottom:58px;"></div>
</div>

<footer class="footer-buttons">
  <button class="btn-tartiary">キャンセル</button>
  <button class="btn-secondary">印刷</button>
  <button class="btn-primary">保存</button>
</footer>